import React from "react";
import { ShieldCheck, Truck, MapPin, HeartHandshake, BadgeCheck } from "lucide-react";

/**
 * Bandeau de réassurance affiché au-dessus des grilles produits
 * (page d'accueil & page boutique). Renforce la confiance client.
 */
export default function TrustStrip({ compact = false }) {
  const items = [
    {
      icon: ShieldCheck,
      title: "Paiement 100% sécurisé",
      desc: "Chiffrement TLS, Square PCI-DSS",
      color: "#00E5FF",
    },
    {
      icon: Truck,
      title: "Expédition rapide",
      desc: "Sous 24 à 48h ouvrées",
      color: "#D926A9",
    },
    {
      icon: BadgeCheck,
      title: "Entreprise française",
      desc: "SIRET 891 655 326 00025",
      color: "#9D4CDD",
    },
    {
      icon: MapPin,
      title: "Boutique physique",
      desc: "20 quai du Roubion, Montélimar",
      color: "#FFD700",
    },
    {
      icon: HeartHandshake,
      title: "Support humain",
      desc: "Guillaume te répond personnellement",
      color: "#D926A9",
    },
  ];

  return (
    <div
      className={`relative ${compact ? "py-3 md:py-4" : "py-8 md:py-10"} ${compact ? "mb-4" : "mb-10"}`}
      data-testid="trust-strip"
    >
      <div className={`rounded-2xl border border-white/10 bg-[#1B132B]/60 backdrop-blur-md ${compact ? "p-3 md:p-4" : "p-5 md:p-6"}`}>
        <div className={`grid grid-cols-2 md:grid-cols-5 ${compact ? "gap-2 md:gap-4" : "gap-4 md:gap-6"}`}>
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                className={`flex items-start ${compact ? "gap-2" : "gap-3"}`}
                data-testid={`trust-item-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div
                  className={`shrink-0 ${compact ? "w-7 h-7 rounded-lg" : "w-10 h-10 rounded-xl"} flex items-center justify-center`}
                  style={{
                    background: `${it.color}1A`,
                    border: `1px solid ${it.color}33`,
                  }}
                >
                  <Icon
                    className={compact ? "w-3.5 h-3.5" : "w-5 h-5"}
                    style={{ color: it.color, filter: `drop-shadow(0 0 6px ${it.color}50)` }}
                  />
                </div>
                <div className="min-w-0">
                  <p className={`font-serif ${compact ? "text-[11px] md:text-xs" : "text-sm md:text-base"} text-[#F7F3FC] leading-snug`}>
                    {it.title}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
